var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.checkDelete}},[_c('i',{staticClass:"ti-trash"}),_vm._v("Xoá tài khoản\n      ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }